import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@chakra-ui/react';
import { IconButton } from '../../IconButton';
import { BxCalendar } from '../../icons';
import { useDateRangePicker } from '../DateRangePickerContext';
export const CalendarButton = () => {
    const { disclosureProps: { onOpen, isOpen }, calendarButtonAria, fcProps: { isDisabled, isReadOnly, isInvalid }, size, styles, } = useDateRangePicker();
    return (_jsx(IconButton, { "data-group": true, size: size, "aria-invalid": isInvalid, onClick: onOpen, variant: "inputAttached", sx: styles.calendarButton, "aria-label": calendarButtonAria, icon: _jsx(Icon, { as: BxCalendar, sx: styles.inputButton }), isActive: isOpen, isDisabled: isDisabled || isReadOnly }));
};
